import { FormRadio, FormRadioGroup, NavigationModal } from '@lmc/ui-kit'
import { useTranslation } from 'react-i18next'

type DoubleBookedModalProps = {
  showPrompt: boolean
  setShowPrompt: (showPrompt: boolean) => void
  confirmNavigation: (allowDoubleBooking?: boolean) => void
  isDoubleBookedSelected: boolean
  setIsDoubleBookedSelected: (value: boolean) => void
  cancelNavigation?: () => void
}

const DoubleBookedModal = ({
  showPrompt,
  setShowPrompt,
  confirmNavigation,
  isDoubleBookedSelected,
  setIsDoubleBookedSelected,
  cancelNavigation,
}: DoubleBookedModalProps) => {
  const { t } = useTranslation()

  const handleConfirm = () => {
    confirmNavigation(isDoubleBookedSelected)
  }

  const handleCancel = () => {
    cancelNavigation?.()
    setShowPrompt(false)
  }

  return (
    <NavigationModal
      modalTitle={t('DOUBLE_BOOKED_MODAL_TITLE')}
      modalContentText={t('DOUBLE_BOOKED_MODAL_DESCRIPTION')}
      modalConfirmText={t('CONFIRM')}
      modalCancelText={t('CANCEL')}
      showPrompt={showPrompt}
      confirmNavigation={handleConfirm}
      cancelNavigation={handleCancel}
      confirmButtonProps={{ variant: 'primary' }}
    >
      <FormRadioGroup
        defaultValue={isDoubleBookedSelected}
        onChange={(e) => setIsDoubleBookedSelected(e.target.value)}
      >
        <FormRadio value={false} text={t('UNALLOCATE_OPTION')} />
        <FormRadio value text={t('DOUBLE_BOOK_OPTION')} />
      </FormRadioGroup>
    </NavigationModal>
  )
}

export default DoubleBookedModal
